export default __webpack_public_path__ + "5ffdab558005ed4fe3a3ab1fdb1f45a2.svg";